import mixpanel from "mixpanel-browser";
import { LiveCampaignData } from "../CampaignInterface/LiveCampaignInterface";
import { LiveCampaignCheckoutCards } from "../Components/LiveCampaignComponents/LiveCampaignCheckoutCards";

interface LiveCampaignMakeItLiveProps {
  collabData: LiveCampaignData;
  AlreadyPaidAmount: number;
  setCurrentStep: (step: number) => void;
  handlePayment: () => void;
  selectedCreatorsLength: number;
  isLiveDatePresent: boolean;
  discountedPrice: number;
  collaborationCharges: number;
  campaignCharges: number;
  usedCollaborationCredits: number;
  usedCampaignAddOn: number;
  usedAnchorsCredits: number;
  setSelectedPaymentMethod: React.Dispatch<React.SetStateAction<string>>;
  selectedPaymentMethod: "card" | "upi";
}

export const LiveCampaignMakeItLive = ({
  collabData,
  AlreadyPaidAmount,
  setCurrentStep,
  handlePayment,
  selectedCreatorsLength,
  isLiveDatePresent,
  discountedPrice,
  collaborationCharges,
  campaignCharges,
  usedCollaborationCredits,
  usedCampaignAddOn,
  usedAnchorsCredits,
  setSelectedPaymentMethod,
  selectedPaymentMethod,
}: LiveCampaignMakeItLiveProps) => {
  return (
    <>
      <div className="flex w-full flex-col items-center justify-start gap-[50px]  py-3 md:py-6 lg:py-12 px-[24px]">
        <LiveCampaignCheckoutCards
          selectedCreatorsLength={selectedCreatorsLength}
          Amount={collabData?.ROI?.safeExpense?.max}
          OnClickNext={() => {
            if (collabData?.Budget?.makeLiveBill) {
              mixpanel.track(
                "Brand Draft Campaign - Success Page: Go To DashBoard - clicked"
              );
              isLiveDatePresent ? setCurrentStep(5) : setCurrentStep(4);
            } else {
              handlePayment();
            }
          }}
          AlreadyPaidAmount={AlreadyPaidAmount}
          isPaid={
            collabData?.Budget?.makeLiveBill !== null &&
            collabData?.Budget?.makeLiveBill !== undefined
          }
          discountedPrice={discountedPrice}
          additionalDiscounts={collabData?.Budget?.additionalDiscounts}
          collaborationCharges={collaborationCharges}
          campaignCharges={campaignCharges}
          usedCollaborationCredits={usedCollaborationCredits}
          usedCampaignAddOn={usedCampaignAddOn}
          usedAnchorsCredits={usedAnchorsCredits}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          selectedPaymentMethod={selectedPaymentMethod}
        />
      </div>
    </>
  );
};
